import React, { useRef, useState } from 'react'
import Bgtwo from '../../assets/images/background/image-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Controller } from 'swiper';
import { useContent } from '../../services';
import CallReservation from './CallReservation';
import ReservationForm from './ReservationForm';

/**
 * ┌─────────────────────────────────────────────────────────────────┐
 * │  RESERVATION DISPLAY TOGGLE                                    │
 * │                                                                │
 * │  Change this value to switch which reservation UI appears      │
 * │  below the testimonials section on the home page:              │
 * │                                                                │
 * │    'call'  → CallReservation  (phone CTA + hours card)         │
 * │    'form'  → ReservationForm  (inline booking form)            │
 * │    'both'  → Show both (form first, then call card)            │
 * │    'none'  → Hide both                                        │
 * └─────────────────────────────────────────────────────────────────┘
 */
const RESERVATION_MODE = 'call'; // ← change to 'call', 'form', 'both', or 'none'

const authorImages = {
  'author-thumb-1.jpg': require('../../assets/images/resource/author-thumb-1.jpg'),
  'author-thumb-2.jpg': require('../../assets/images/resource/author-thumb-2.jpg'),
  'author-thumb-3.jpg': require('../../assets/images/resource/author-thumb-3.jpg'),
};

SwiperCore.use([Controller]);

function Contact() {

    const swiper1 = useRef(null);
    const swiper2 = useRef(null);

    const [flag, setflag] = useState(false)
    const { data: testimonials, loading: loadingT } = useContent('homeTestimonials');

    const slider2 = useRef()
    const duration = 500;
    const syncPosition = (e) => {
        if (!flag) {
            setflag(false)
            if (slider2.current) {
                slider2.current.to(e.item.index, duration)
            }
            setflag(false)
        }
    }

    if (loadingT || !testimonials) return null;

    return (
        <>
            <div className="testimonials-section" >
                <div className="image-layer" style={{ backgroundImage: `url(${Bgtwo})` }}></div>
                <div className="auto-container">
                    <div className="carousel-box owl-theme">
                        <Swiper className="testi-top"
                            ref={swiper1}
                            controller={{ control: swiper2.current }}
                            items={1} loop margin={10} autoplay onChange={(e) => syncPosition(e)}>
                            {testimonials.items.map((item) => (
                                <SwiperSlide key={item.id} className="slide-item">
                                    <div className="slide-content">
                                        <div className="quotes">"</div>
                                        <div className="text quote-text">{item.quote}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                            {testimonials.items.map((item) => (
                                <SwiperSlide key={`dup-${item.id}`} className="slide-item">
                                    <div className="slide-content">
                                        <div className="quotes">"</div>
                                        <div className="text quote-text">{item.quote}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="separator"><span></span><span></span><span></span></div>
                        <div className="thumbs-carousel-box">
                            <Swiper className="testi-thumbs" loop={true} autoplay={true}>
                                {testimonials.items.map((item) => (
                                    <SwiperSlide key={item.id} className="slide-item">
                                        <div className="image">
                                            <img src={authorImages[item.image]} alt="" />
                                        </div>
                                        <div className="auth-title">{item.author}</div>
                                    </SwiperSlide>
                                ))}
                                {testimonials.items.map((item) => (
                                    <SwiperSlide key={`dup-${item.id}`} className="slide-item">
                                        <div className="image">
                                            <img src={authorImages[item.image]} alt="" />
                                        </div>
                                        <div className="auth-title">{item.author}</div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Reservation UI — controlled by RESERVATION_MODE toggle ── */}
            {(RESERVATION_MODE === 'form' || RESERVATION_MODE === 'both') && <ReservationForm />}
            {(RESERVATION_MODE === 'call' || RESERVATION_MODE === 'both') && <CallReservation />}
        </>
    )
}

export default Contact
